import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import DiagonalArrowIcon from "../../../generated/DiagonalArrowIcon/DiagonalArrowIcon20";
import { Icon } from "../../icon/Icon";
import BackIcon from "./../../../generated/BackIcon/BackIcon20";
const getArrow = rotation => {
  switch (rotation) {
    case 45:
    case 135:
    case 225:
    case 315:
      return /*#__PURE__*/React.createElement(DiagonalArrowIcon, {
        color: "currentColor"
      });
    default:
      return /*#__PURE__*/React.createElement(BackIcon, {
        color: "currentColor"
      });
  }
};
const getRotation = rotation => {
  switch (rotation) {
    case 45:
    case 135:
    case 225:
    case 315:
      return rotation - 45;
    default:
      return rotation + 90;
  }
};
export const DirectionalArrowIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color,
    size,
    rotation,
    style,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    color: color,
    ref: ref,
    size: size,
    style: {
      transform: `rotate(${getRotation(rotation)}deg)`,
      ...style
    }
  }, rest), getArrow(rotation));
});
DirectionalArrowIcon.displayName = "DirectionalArrowIcon";
//# sourceMappingURL=DirectionalArrowIcon.js.map